import React from 'react';
import { Route } from 'react-router-dom';

import { Module } from '../../utils';
import Products from './views/Products';
import Product from './views/Product';
import sagas from './sagas';

export default new Module({
  routes: [
    <Route exact path="/products" component={Products} />,
    <Route exact path="/checkOrder/:id" component={Product} />,
  ],
  sagas
});